import { render, staticRenderFns } from "./Season.vue?vue&type=template&id=2d3a1f51&scoped=true&"
import script from "./Season.vue?vue&type=script&lang=js&"
export * from "./Season.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a1f51",
  null
  
)

export default component.exports